import styled from "@emotion/styled";

import { fontRoboto, fontSourceSerif4, theme } from "shared/lib/styles";

import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  inline-size: 100%;
  padding-block-start: 12px;
  border-block-start: 1px #000000 solid;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  ${theme.breakpoints.up("tablet")} {
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
  }
`;

export const Title = styled.div`
  flex-shrink: 0;

  padding-block-end: 10px;

  color: #000000;
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontSourceSerif4};
  line-height: 90%;
  letter-spacing: -1.4px;
`;

export const TitleLink = styled(EntityLink)`
  flex-shrink: 0;

  padding-block-end: 10px;

  color: #000000;
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontSourceSerif4};
  line-height: 90%;
  letter-spacing: -1.4px;
`;

export const Dash = styled.span`
  margin-inline: 16px 8px;

  color: #666666;

  ${theme.breakpoints.only("mobile")} {
    display: none;
  }
`;

export const Description = styled.div`
  color: #666666;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: normal;
`;
